<template>
  <div>
      <div class="text-center" v-if="!codeType">
          <h2 class="p-t-20">请选择登录方式</h2>
          <Row style="padding:40px 0px;">
            <i-col span="12">
                <div style="width:100%;cursor:pointer;" @click="changeCodeType('qywx')">
                  <img src="../assets/imgs/qrwx.jpg" style="width:100px;height:100px;" />
                </div>
                <p>企业微信登录</p>
            </i-col>
            <i-col span="12">
              <div style="width:100%;cursor:pointer;" @click="changeCodeType('wx')">
                  <img src="../assets/imgs/wx.jpg" style="width:100px;height:100px;" />
                </div>
                <p>微信登录</p>
            </i-col>
            <!-- <i-col span="8">
              <div style="width:100%;cursor:pointer;" @click="changeCodeType('qywx_nb')">
                  <img src="../assets/imgs/明日传播.jpg" style="width:100px;height:100px;" />
                </div>
                <p>明日传播</p>
            </i-col> -->
          </Row>
          <p><a href="https://www.google.cn/chrome/index.html" target="_blank">请下载使用指定浏览器“chrome”登录</a></p>
      </div>

    <qywxlogin  v-if="codeType==='qywx'"></qywxlogin>
    <wxlogin  v-else-if="codeType==='wx'" ></wxlogin>
    <qywxloginNb v-else-if="codeType==='qywx_nb'"></qywxloginNb>
    <a v-if="codeType" @click="changeCodeType('')">选择其他登录方式</a>
  </div>
</template>

<script>
import wxlogin from './wxlogin2'
import qywxlogin from './qywxlogin'
import qywxloginNb from './qywxlogin_nb'

export default {
  components: {
    wxlogin,
    qywxlogin,
    qywxloginNb
  },
  data () {
    return {
      codeType: ''
    }
  },
  mounted () {
    this.codeType = ''
  },
  methods: {
    changeCodeType (type) {
      this.codeType = type
    }
  }
}
</script>
